"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutationNotificationHelpers = void 0;
var FlowDemoted_1 = require("./FlowDemoted");
var SpaceCreated_1 = require("./SpaceCreated");
var SegmentationDemoted_1 = require("./SegmentationDemoted");
var GameEventCreated_1 = require("./GameEventCreated");
var ConfigurationDemoted_1 = require("./ConfigurationDemoted");
var ItemDemoted_1 = require("./ItemDemoted");
var BlueprintEntityPromoted_1 = require("./BlueprintEntityPromoted");
var CouponUpdated_1 = require("./CouponUpdated");
var GameEventDeleted_1 = require("./GameEventDeleted");
var GameEventPromoted_1 = require("./GameEventPromoted");
var AudienceUpdated_1 = require("./AudienceUpdated");
var CloudFunctionDemoted_1 = require("./CloudFunctionDemoted");
var ItemPromoted_1 = require("./ItemPromoted");
var FlowUpdated_1 = require("./FlowUpdated");
var CloudFunctionUpdated_1 = require("./CloudFunctionUpdated");
var FileUpdated_1 = require("./FileUpdated");
var SynapseProblemDemoted_1 = require("./SynapseProblemDemoted");
var GameEventDemoted_1 = require("./GameEventDemoted");
var BlueprintEntityDemoted_1 = require("./BlueprintEntityDemoted");
var FlowPromoted_1 = require("./FlowPromoted");
var SynapseProblemDeleted_1 = require("./SynapseProblemDeleted");
var AudienceDeleted_1 = require("./AudienceDeleted");
var TraitsCreated_1 = require("./TraitsCreated");
var BlueprintEntityUpdated_1 = require("./BlueprintEntityUpdated");
var BlueprintEntityDeleted_1 = require("./BlueprintEntityDeleted");
var SynapseProblemUpdated_1 = require("./SynapseProblemUpdated");
var AssetFileCreated_1 = require("./AssetFileCreated");
var AssetFileRevisionCreated_1 = require("./AssetFileRevisionCreated");
var LeaderboardPromoted_1 = require("./LeaderboardPromoted");
var PackageDeleted_1 = require("./PackageDeleted");
var FlowCreated_1 = require("./FlowCreated");
var EventsMapperCreated_1 = require("./EventsMapperCreated");
var PackagePromoted_1 = require("./PackagePromoted");
var SegmentationPromoted_1 = require("./SegmentationPromoted");
var TeamTemplatePromoted_1 = require("./TeamTemplatePromoted");
var ItemDeleted_1 = require("./ItemDeleted");
var SpaceUpdated_1 = require("./SpaceUpdated");
var CloudFunctionPromoted_1 = require("./CloudFunctionPromoted");
var FileDeleted_1 = require("./FileDeleted");
var SpaceDeleted_1 = require("./SpaceDeleted");
var TeamTemplateUpdated_1 = require("./TeamTemplateUpdated");
var CloudFunctionDeleted_1 = require("./CloudFunctionDeleted");
var TeamTemplateDemoted_1 = require("./TeamTemplateDemoted");
var CouponDemoted_1 = require("./CouponDemoted");
var SynapseProblemPromoted_1 = require("./SynapseProblemPromoted");
var ConfigurationCreated_1 = require("./ConfigurationCreated");
var CouponCreated_1 = require("./CouponCreated");
var FileRevisionCreated_1 = require("./FileRevisionCreated");
var TeamTemplateCreated_1 = require("./TeamTemplateCreated");
var ScriptCreated_1 = require("./ScriptCreated");
var ExperimentUpdated_1 = require("./ExperimentUpdated");
var CouponDeleted_1 = require("./CouponDeleted");
var PackageDemoted_1 = require("./PackageDemoted");
var LeaderboardDemoted_1 = require("./LeaderboardDemoted");
var FlowDeleted_1 = require("./FlowDeleted");
var ScriptUpdated_1 = require("./ScriptUpdated");
var CloudFunctionCreated_1 = require("./CloudFunctionCreated");
var ScriptDeleted_1 = require("./ScriptDeleted");
var MatchPromoted_1 = require("./MatchPromoted");
var LeaderboardUpdated_1 = require("./LeaderboardUpdated");
var ExperimentCreated_1 = require("./ExperimentCreated");
var ExperimentDeleted_1 = require("./ExperimentDeleted");
var SynapseProblemCreated_1 = require("./SynapseProblemCreated");
var FileCreated_1 = require("./FileCreated");
var FileRevisionDeleted_1 = require("./FileRevisionDeleted");
var ScriptActivationUpdated_1 = require("./ScriptActivationUpdated");
var MatchDeleted_1 = require("./MatchDeleted");
var AudienceCreated_1 = require("./AudienceCreated");
var FileRevisionUpdated_1 = require("./FileRevisionUpdated");
var BlueprintEntityCreated_1 = require("./BlueprintEntityCreated");
var MatchUpdated_1 = require("./MatchUpdated");
var SegmentationCreated_1 = require("./SegmentationCreated");
var LeaderboardCreated_1 = require("./LeaderboardCreated");
var ItemUpdated_1 = require("./ItemUpdated");
var ItemCreated_1 = require("./ItemCreated");
var ConfigurationPromoted_1 = require("./ConfigurationPromoted");
var LeaderboardDeleted_1 = require("./LeaderboardDeleted");
var MatchDemoted_1 = require("./MatchDemoted");
var GameEventUpdated_1 = require("./GameEventUpdated");
var PackageCreated_1 = require("./PackageCreated");
var MatchCreated_1 = require("./MatchCreated");
var TeamTemplateDeleted_1 = require("./TeamTemplateDeleted");
var ExperimentPromoted_1 = require("./ExperimentPromoted");
var PackageUpdated_1 = require("./PackageUpdated");
var CouponPromoted_1 = require("./CouponPromoted");
var ExperimentDemoted_1 = require("./ExperimentDemoted");
var MutationNotificationHelpers = (function () {
    function MutationNotificationHelpers() {
    }
    MutationNotificationHelpers.isInstanceOf = function (o) {
        if (!o['getClassName'] || typeof o['getClassName'] !== 'function') {
            return false;
        }
        return o instanceof SpaceCreated_1.SpaceCreated || o instanceof SpaceUpdated_1.SpaceUpdated || o instanceof SpaceDeleted_1.SpaceDeleted || o instanceof FileCreated_1.FileCreated || o instanceof FileUpdated_1.FileUpdated || o instanceof FileDeleted_1.FileDeleted || o instanceof FileRevisionCreated_1.FileRevisionCreated || o instanceof FileRevisionUpdated_1.FileRevisionUpdated || o instanceof FileRevisionDeleted_1.FileRevisionDeleted || o instanceof AssetFileCreated_1.AssetFileCreated || o instanceof AssetFileRevisionCreated_1.AssetFileRevisionCreated || o instanceof ConfigurationCreated_1.ConfigurationCreated || o instanceof ConfigurationPromoted_1.ConfigurationPromoted || o instanceof ConfigurationDemoted_1.ConfigurationDemoted || o instanceof TraitsCreated_1.TraitsCreated || o instanceof EventsMapperCreated_1.EventsMapperCreated || o instanceof ExperimentCreated_1.ExperimentCreated || o instanceof ExperimentUpdated_1.ExperimentUpdated || o instanceof ExperimentPromoted_1.ExperimentPromoted || o instanceof ExperimentDemoted_1.ExperimentDemoted || o instanceof ExperimentDeleted_1.ExperimentDeleted || o instanceof GameEventCreated_1.GameEventCreated || o instanceof GameEventUpdated_1.GameEventUpdated || o instanceof GameEventPromoted_1.GameEventPromoted || o instanceof GameEventDemoted_1.GameEventDemoted || o instanceof GameEventDeleted_1.GameEventDeleted || o instanceof FlowCreated_1.FlowCreated || o instanceof FlowUpdated_1.FlowUpdated || o instanceof FlowPromoted_1.FlowPromoted || o instanceof FlowDemoted_1.FlowDemoted || o instanceof FlowDeleted_1.FlowDeleted || o instanceof ItemCreated_1.ItemCreated || o instanceof ItemUpdated_1.ItemUpdated || o instanceof ItemPromoted_1.ItemPromoted || o instanceof ItemDemoted_1.ItemDemoted || o instanceof ItemDeleted_1.ItemDeleted || o instanceof PackageCreated_1.PackageCreated || o instanceof PackageUpdated_1.PackageUpdated || o instanceof PackagePromoted_1.PackagePromoted || o instanceof PackageDemoted_1.PackageDemoted || o instanceof PackageDeleted_1.PackageDeleted || o instanceof CouponCreated_1.CouponCreated || o instanceof CouponUpdated_1.CouponUpdated || o instanceof CouponPromoted_1.CouponPromoted || o instanceof CouponDemoted_1.CouponDemoted || o instanceof CouponDeleted_1.CouponDeleted || o instanceof LeaderboardCreated_1.LeaderboardCreated || o instanceof LeaderboardUpdated_1.LeaderboardUpdated || o instanceof LeaderboardPromoted_1.LeaderboardPromoted || o instanceof LeaderboardDemoted_1.LeaderboardDemoted || o instanceof LeaderboardDeleted_1.LeaderboardDeleted || o instanceof MatchCreated_1.MatchCreated || o instanceof MatchUpdated_1.MatchUpdated || o instanceof MatchPromoted_1.MatchPromoted || o instanceof MatchDemoted_1.MatchDemoted || o instanceof MatchDeleted_1.MatchDeleted || o instanceof TeamTemplateCreated_1.TeamTemplateCreated || o instanceof TeamTemplateUpdated_1.TeamTemplateUpdated || o instanceof TeamTemplatePromoted_1.TeamTemplatePromoted || o instanceof TeamTemplateDemoted_1.TeamTemplateDemoted || o instanceof TeamTemplateDeleted_1.TeamTemplateDeleted || o instanceof SynapseProblemCreated_1.SynapseProblemCreated || o instanceof SynapseProblemUpdated_1.SynapseProblemUpdated || o instanceof SynapseProblemPromoted_1.SynapseProblemPromoted || o instanceof SynapseProblemDemoted_1.SynapseProblemDemoted || o instanceof SynapseProblemDeleted_1.SynapseProblemDeleted || o instanceof SegmentationCreated_1.SegmentationCreated || o instanceof SegmentationPromoted_1.SegmentationPromoted || o instanceof SegmentationDemoted_1.SegmentationDemoted || o instanceof CloudFunctionCreated_1.CloudFunctionCreated || o instanceof CloudFunctionUpdated_1.CloudFunctionUpdated || o instanceof CloudFunctionPromoted_1.CloudFunctionPromoted || o instanceof CloudFunctionDemoted_1.CloudFunctionDemoted || o instanceof CloudFunctionDeleted_1.CloudFunctionDeleted || o instanceof AudienceCreated_1.AudienceCreated || o instanceof AudienceUpdated_1.AudienceUpdated || o instanceof AudienceDeleted_1.AudienceDeleted || o instanceof ScriptCreated_1.ScriptCreated || o instanceof ScriptUpdated_1.ScriptUpdated || o instanceof ScriptDeleted_1.ScriptDeleted || o instanceof ScriptActivationUpdated_1.ScriptActivationUpdated || o instanceof BlueprintEntityCreated_1.BlueprintEntityCreated || o instanceof BlueprintEntityUpdated_1.BlueprintEntityUpdated || o instanceof BlueprintEntityPromoted_1.BlueprintEntityPromoted || o instanceof BlueprintEntityDemoted_1.BlueprintEntityDemoted || o instanceof BlueprintEntityDeleted_1.BlueprintEntityDeleted;
    };
    MutationNotificationHelpers.serialize = function (adt) {
        var _a;
        var className = adt.getClassName();
        return _a = {},
            _a[className] = adt.serialize(),
            _a;
    };
    MutationNotificationHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'SpaceCreated': return new SpaceCreated_1.SpaceCreated(content);
            case 'SpaceUpdated': return new SpaceUpdated_1.SpaceUpdated(content);
            case 'SpaceDeleted': return new SpaceDeleted_1.SpaceDeleted(content);
            case 'FileCreated': return new FileCreated_1.FileCreated(content);
            case 'FileUpdated': return new FileUpdated_1.FileUpdated(content);
            case 'FileDeleted': return new FileDeleted_1.FileDeleted(content);
            case 'FileRevisionCreated': return new FileRevisionCreated_1.FileRevisionCreated(content);
            case 'FileRevisionUpdated': return new FileRevisionUpdated_1.FileRevisionUpdated(content);
            case 'FileRevisionDeleted': return new FileRevisionDeleted_1.FileRevisionDeleted(content);
            case 'AssetFileCreated': return new AssetFileCreated_1.AssetFileCreated(content);
            case 'AssetFileRevisionCreated': return new AssetFileRevisionCreated_1.AssetFileRevisionCreated(content);
            case 'ConfigurationCreated': return new ConfigurationCreated_1.ConfigurationCreated(content);
            case 'ConfigurationPromoted': return new ConfigurationPromoted_1.ConfigurationPromoted(content);
            case 'ConfigurationDemoted': return new ConfigurationDemoted_1.ConfigurationDemoted(content);
            case 'TraitsCreated': return new TraitsCreated_1.TraitsCreated(content);
            case 'EventsMapperCreated': return new EventsMapperCreated_1.EventsMapperCreated(content);
            case 'ExperimentCreated': return new ExperimentCreated_1.ExperimentCreated(content);
            case 'ExperimentUpdated': return new ExperimentUpdated_1.ExperimentUpdated(content);
            case 'ExperimentPromoted': return new ExperimentPromoted_1.ExperimentPromoted(content);
            case 'ExperimentDemoted': return new ExperimentDemoted_1.ExperimentDemoted(content);
            case 'ExperimentDeleted': return new ExperimentDeleted_1.ExperimentDeleted(content);
            case 'GameEventCreated': return new GameEventCreated_1.GameEventCreated(content);
            case 'GameEventUpdated': return new GameEventUpdated_1.GameEventUpdated(content);
            case 'GameEventPromoted': return new GameEventPromoted_1.GameEventPromoted(content);
            case 'GameEventDemoted': return new GameEventDemoted_1.GameEventDemoted(content);
            case 'GameEventDeleted': return new GameEventDeleted_1.GameEventDeleted(content);
            case 'FlowCreated': return new FlowCreated_1.FlowCreated(content);
            case 'FlowUpdated': return new FlowUpdated_1.FlowUpdated(content);
            case 'FlowPromoted': return new FlowPromoted_1.FlowPromoted(content);
            case 'FlowDemoted': return new FlowDemoted_1.FlowDemoted(content);
            case 'FlowDeleted': return new FlowDeleted_1.FlowDeleted(content);
            case 'ItemCreated': return new ItemCreated_1.ItemCreated(content);
            case 'ItemUpdated': return new ItemUpdated_1.ItemUpdated(content);
            case 'ItemPromoted': return new ItemPromoted_1.ItemPromoted(content);
            case 'ItemDemoted': return new ItemDemoted_1.ItemDemoted(content);
            case 'ItemDeleted': return new ItemDeleted_1.ItemDeleted(content);
            case 'PackageCreated': return new PackageCreated_1.PackageCreated(content);
            case 'PackageUpdated': return new PackageUpdated_1.PackageUpdated(content);
            case 'PackagePromoted': return new PackagePromoted_1.PackagePromoted(content);
            case 'PackageDemoted': return new PackageDemoted_1.PackageDemoted(content);
            case 'PackageDeleted': return new PackageDeleted_1.PackageDeleted(content);
            case 'CouponCreated': return new CouponCreated_1.CouponCreated(content);
            case 'CouponUpdated': return new CouponUpdated_1.CouponUpdated(content);
            case 'CouponPromoted': return new CouponPromoted_1.CouponPromoted(content);
            case 'CouponDemoted': return new CouponDemoted_1.CouponDemoted(content);
            case 'CouponDeleted': return new CouponDeleted_1.CouponDeleted(content);
            case 'LeaderboardCreated': return new LeaderboardCreated_1.LeaderboardCreated(content);
            case 'LeaderboardUpdated': return new LeaderboardUpdated_1.LeaderboardUpdated(content);
            case 'LeaderboardPromoted': return new LeaderboardPromoted_1.LeaderboardPromoted(content);
            case 'LeaderboardDemoted': return new LeaderboardDemoted_1.LeaderboardDemoted(content);
            case 'LeaderboardDeleted': return new LeaderboardDeleted_1.LeaderboardDeleted(content);
            case 'MatchCreated': return new MatchCreated_1.MatchCreated(content);
            case 'MatchUpdated': return new MatchUpdated_1.MatchUpdated(content);
            case 'MatchPromoted': return new MatchPromoted_1.MatchPromoted(content);
            case 'MatchDemoted': return new MatchDemoted_1.MatchDemoted(content);
            case 'MatchDeleted': return new MatchDeleted_1.MatchDeleted(content);
            case 'TeamTemplateCreated': return new TeamTemplateCreated_1.TeamTemplateCreated(content);
            case 'TeamTemplateUpdated': return new TeamTemplateUpdated_1.TeamTemplateUpdated(content);
            case 'TeamTemplatePromoted': return new TeamTemplatePromoted_1.TeamTemplatePromoted(content);
            case 'TeamTemplateDemoted': return new TeamTemplateDemoted_1.TeamTemplateDemoted(content);
            case 'TeamTemplateDeleted': return new TeamTemplateDeleted_1.TeamTemplateDeleted(content);
            case 'SynapseProblemCreated': return new SynapseProblemCreated_1.SynapseProblemCreated(content);
            case 'SynapseProblemUpdated': return new SynapseProblemUpdated_1.SynapseProblemUpdated(content);
            case 'SynapseProblemPromoted': return new SynapseProblemPromoted_1.SynapseProblemPromoted(content);
            case 'SynapseProblemDemoted': return new SynapseProblemDemoted_1.SynapseProblemDemoted(content);
            case 'SynapseProblemDeleted': return new SynapseProblemDeleted_1.SynapseProblemDeleted(content);
            case 'SegmentationCreated': return new SegmentationCreated_1.SegmentationCreated(content);
            case 'SegmentationPromoted': return new SegmentationPromoted_1.SegmentationPromoted(content);
            case 'SegmentationDemoted': return new SegmentationDemoted_1.SegmentationDemoted(content);
            case 'CloudFunctionCreated': return new CloudFunctionCreated_1.CloudFunctionCreated(content);
            case 'CloudFunctionUpdated': return new CloudFunctionUpdated_1.CloudFunctionUpdated(content);
            case 'CloudFunctionPromoted': return new CloudFunctionPromoted_1.CloudFunctionPromoted(content);
            case 'CloudFunctionDemoted': return new CloudFunctionDemoted_1.CloudFunctionDemoted(content);
            case 'CloudFunctionDeleted': return new CloudFunctionDeleted_1.CloudFunctionDeleted(content);
            case 'AudienceCreated': return new AudienceCreated_1.AudienceCreated(content);
            case 'AudienceUpdated': return new AudienceUpdated_1.AudienceUpdated(content);
            case 'AudienceDeleted': return new AudienceDeleted_1.AudienceDeleted(content);
            case 'ScriptCreated': return new ScriptCreated_1.ScriptCreated(content);
            case 'ScriptUpdated': return new ScriptUpdated_1.ScriptUpdated(content);
            case 'ScriptDeleted': return new ScriptDeleted_1.ScriptDeleted(content);
            case 'ScriptActivationUpdated': return new ScriptActivationUpdated_1.ScriptActivationUpdated(content);
            case 'BlueprintEntityCreated': return new BlueprintEntityCreated_1.BlueprintEntityCreated(content);
            case 'BlueprintEntityUpdated': return new BlueprintEntityUpdated_1.BlueprintEntityUpdated(content);
            case 'BlueprintEntityPromoted': return new BlueprintEntityPromoted_1.BlueprintEntityPromoted(content);
            case 'BlueprintEntityDemoted': return new BlueprintEntityDemoted_1.BlueprintEntityDemoted(content);
            case 'BlueprintEntityDeleted': return new BlueprintEntityDeleted_1.BlueprintEntityDeleted(content);
            default:
                throw new Error('Unknown type id ' + id + ' for MutationNotification');
        }
    };
    return MutationNotificationHelpers;
}());
exports.MutationNotificationHelpers = MutationNotificationHelpers;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register('net.playq.octopus.notifications.MutationNotification', {
    full: 'net.playq.octopus.notifications.MutationNotification',
    short: 'MutationNotification',
    package: 'net.playq.octopus.notifications',
    type: irt_1.IntrospectorTypes.Adt,
    options: [
        {
            name: 'SpaceCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SpaceCreated' }
        },
        {
            name: 'SpaceUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SpaceUpdated' }
        },
        {
            name: 'SpaceDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SpaceDeleted' }
        },
        {
            name: 'FileCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FileCreated' }
        },
        {
            name: 'FileUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FileUpdated' }
        },
        {
            name: 'FileDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FileDeleted' }
        },
        {
            name: 'FileRevisionCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FileRevisionCreated' }
        },
        {
            name: 'FileRevisionUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FileRevisionUpdated' }
        },
        {
            name: 'FileRevisionDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FileRevisionDeleted' }
        },
        {
            name: 'AssetFileCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.AssetFileCreated' }
        },
        {
            name: 'AssetFileRevisionCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.AssetFileRevisionCreated' }
        },
        {
            name: 'ConfigurationCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ConfigurationCreated' }
        },
        {
            name: 'ConfigurationPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ConfigurationPromoted' }
        },
        {
            name: 'ConfigurationDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ConfigurationDemoted' }
        },
        {
            name: 'TraitsCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.TraitsCreated' }
        },
        {
            name: 'EventsMapperCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.EventsMapperCreated' }
        },
        {
            name: 'ExperimentCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ExperimentCreated' }
        },
        {
            name: 'ExperimentUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ExperimentUpdated' }
        },
        {
            name: 'ExperimentPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ExperimentPromoted' }
        },
        {
            name: 'ExperimentDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ExperimentDemoted' }
        },
        {
            name: 'ExperimentDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ExperimentDeleted' }
        },
        {
            name: 'GameEventCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.GameEventCreated' }
        },
        {
            name: 'GameEventUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.GameEventUpdated' }
        },
        {
            name: 'GameEventPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.GameEventPromoted' }
        },
        {
            name: 'GameEventDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.GameEventDemoted' }
        },
        {
            name: 'GameEventDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.GameEventDeleted' }
        },
        {
            name: 'FlowCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FlowCreated' }
        },
        {
            name: 'FlowUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FlowUpdated' }
        },
        {
            name: 'FlowPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FlowPromoted' }
        },
        {
            name: 'FlowDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FlowDemoted' }
        },
        {
            name: 'FlowDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.FlowDeleted' }
        },
        {
            name: 'ItemCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ItemCreated' }
        },
        {
            name: 'ItemUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ItemUpdated' }
        },
        {
            name: 'ItemPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ItemPromoted' }
        },
        {
            name: 'ItemDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ItemDemoted' }
        },
        {
            name: 'ItemDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ItemDeleted' }
        },
        {
            name: 'PackageCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.PackageCreated' }
        },
        {
            name: 'PackageUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.PackageUpdated' }
        },
        {
            name: 'PackagePromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.PackagePromoted' }
        },
        {
            name: 'PackageDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.PackageDemoted' }
        },
        {
            name: 'PackageDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.PackageDeleted' }
        },
        {
            name: 'CouponCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.CouponCreated' }
        },
        {
            name: 'CouponUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.CouponUpdated' }
        },
        {
            name: 'CouponPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.CouponPromoted' }
        },
        {
            name: 'CouponDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.CouponDemoted' }
        },
        {
            name: 'CouponDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.CouponDeleted' }
        },
        {
            name: 'LeaderboardCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.LeaderboardCreated' }
        },
        {
            name: 'LeaderboardUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.LeaderboardUpdated' }
        },
        {
            name: 'LeaderboardPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.LeaderboardPromoted' }
        },
        {
            name: 'LeaderboardDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.LeaderboardDemoted' }
        },
        {
            name: 'LeaderboardDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.LeaderboardDeleted' }
        },
        {
            name: 'MatchCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.MatchCreated' }
        },
        {
            name: 'MatchUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.MatchUpdated' }
        },
        {
            name: 'MatchPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.MatchPromoted' }
        },
        {
            name: 'MatchDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.MatchDemoted' }
        },
        {
            name: 'MatchDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.MatchDeleted' }
        },
        {
            name: 'TeamTemplateCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.TeamTemplateCreated' }
        },
        {
            name: 'TeamTemplateUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.TeamTemplateUpdated' }
        },
        {
            name: 'TeamTemplatePromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.TeamTemplatePromoted' }
        },
        {
            name: 'TeamTemplateDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.TeamTemplateDemoted' }
        },
        {
            name: 'TeamTemplateDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.TeamTemplateDeleted' }
        },
        {
            name: 'SynapseProblemCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SynapseProblemCreated' }
        },
        {
            name: 'SynapseProblemUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SynapseProblemUpdated' }
        },
        {
            name: 'SynapseProblemPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SynapseProblemPromoted' }
        },
        {
            name: 'SynapseProblemDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SynapseProblemDemoted' }
        },
        {
            name: 'SynapseProblemDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SynapseProblemDeleted' }
        },
        {
            name: 'SegmentationCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SegmentationCreated' }
        },
        {
            name: 'SegmentationPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SegmentationPromoted' }
        },
        {
            name: 'SegmentationDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.SegmentationDemoted' }
        },
        {
            name: 'CloudFunctionCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.CloudFunctionCreated' }
        },
        {
            name: 'CloudFunctionUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.CloudFunctionUpdated' }
        },
        {
            name: 'CloudFunctionPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.CloudFunctionPromoted' }
        },
        {
            name: 'CloudFunctionDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.CloudFunctionDemoted' }
        },
        {
            name: 'CloudFunctionDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.CloudFunctionDeleted' }
        },
        {
            name: 'AudienceCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.AudienceCreated' }
        },
        {
            name: 'AudienceUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.AudienceUpdated' }
        },
        {
            name: 'AudienceDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.AudienceDeleted' }
        },
        {
            name: 'ScriptCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ScriptCreated' }
        },
        {
            name: 'ScriptUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ScriptUpdated' }
        },
        {
            name: 'ScriptDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ScriptDeleted' }
        },
        {
            name: 'ScriptActivationUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.ScriptActivationUpdated' }
        },
        {
            name: 'BlueprintEntityCreated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.BlueprintEntityCreated' }
        },
        {
            name: 'BlueprintEntityUpdated',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.BlueprintEntityUpdated' }
        },
        {
            name: 'BlueprintEntityPromoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.BlueprintEntityPromoted' }
        },
        {
            name: 'BlueprintEntityDemoted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.BlueprintEntityDemoted' }
        },
        {
            name: 'BlueprintEntityDeleted',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.notifications.BlueprintEntityDeleted' }
        }
    ]
});
//# sourceMappingURL=MutationNotification.js.map